<mat-toolbar>
    <div class="logo-block" [routerLink]="['/']">
        <div style=" overflow: clip; width:50px;">
            <a class="logo">@if (testEnv) {
                <span class="env">{{ testEnv }}</span>
            }</a>
        </div>
        IWO-FURN GW
    </div>
    <button [routerLink]="['/job']" mat-button [routerLinkActive]="['active']">
        Jobs
    </button>
    <button [routerLink]="['/tools/dds-check']" [routerLinkActive]="['active']" mat-button>
        DDS-Check
    </button>
    <button [routerLink]="['/customer']" [routerLinkActive]="['active']" mat-button>
        Customers
    </button>
    <span class="toolbar-item-spacer"></span>
</mat-toolbar>
